module.exports = __webpack_public_path__ + "static/media/plaidLogo1.31d6c9b5.png";